<template>
    <sa-page-layout :btnNewVisible="false" :btnRefreshVisible="true" @refresh="onRefresh" :pathResource="pathResource" :linkedit="linkedit" :showModalLoading="showModalLoading">
        <template slot="toolbar">
            <b-button class="float-sm-right" variant="success btn-toolbar sa-margin-right" size="sm" @click="onClickNuovo">
                <b-icon icon="plus"> </b-icon>
                Nuovo
            </b-button>
        </template>
        <!-- <template slot="table-filter">
      
    </template> -->
        <template slot="table-body">
            <consensi-list-component ref="cmpConsensiListComponent" @afterLoadData="onAfterLoadData"></consensi-list-component>
        </template>
    </sa-page-layout>
</template>

<script>
import SaPageLayout from "../../../template/sa/components/layout/contents/SaPageLayout.vue";
import UtilityMixin from "../../utility/UtilityMixin";
import ConsensiListComponent from "../components/ConsensiListComponent.vue";

export default {
    components: { SaPageLayout, ConsensiListComponent },
    data() {
        return {
            showModalLoading: false,
            btnNewVisible: true,
            btnRefreshVisible: true,

            filtro: {
                nomeConsenso: null,
                codiceStruttura: null,
                sezione: null,
                tipologia: null,
            },

            pathResource: null,
            linkedit: "pua",
        };
    },
    mounted() {
        let me = this;
        this.loadStrutture();
        me.loadData();
        let sessionStorage = window.sessionStorage;
        if (sessionStorage["filtroConsensi"]) {
            this.filtro = JSON.parse(sessionStorage["filtroConsensi"]);
        }
    },
    methods: {
        loadData() {
            let me = this;
            me.showModalLoading = true;
            me.$refs.cmpConsensiListComponent.init(me.filtro);
        },
        onRefresh() {
            let me = this;
            me.loadData();
        },
        onAfterLoadData() {
            let me = this;
            me.showModalLoading = false;
        },
        onClickNuovo() {
            this.$refs.cmpConsensiListComponent.openModalNuovoCosenso();
        },

        loadStrutture() {
            UtilityMixin.methods.loadDataResources("/strutture", {}, this.loadStruttureSuccess, this.loadStruttureError);
        },
        loadStruttureSuccess(response) {
            this.struttureOptions = response.data.data;
        },
        loadStruttureError(error) {
            console.log(error);
        },
    },
};
</script>

<style></style>
